import { useAllStationsDescriptionFooters } from '@app/modules/fragments/hooks/useDescriptionFooters';
import { Box } from '@mui/material';
import { useFormikContext } from 'formik';
import { FormattedMessage } from 'react-intl';

export function ContentAiBodyFooterSelector() {
  const { values, setFieldValue } = useFormikContext<{
    title?: string;
    body?: string;
  }>();

  const footers = useAllStationsDescriptionFooters();

  function setFooter(footer: string) {
    setFieldValue('body', `${values.body} \n\n${footer}`);
  }

  if (!footers.length) {
    return null;
  }

  return (
    <Box display={'flex'}>
      <FormattedMessage id="contentAi.userArticle.useFooter" defaultMessage="Usar footer:" />
      <Box display={'flex'} gap={1} ml={1}>
        {footers.map((f, index) => (
          <Box key={`box-${index}`}>
            {f.map((foo: any) => {
              return (
                <a
                  href={'#'}
                  onClick={(event) => {
                    event.preventDefault();
                    setFooter(foo.content);
                  }}
                >
                  {foo.name}
                </a>
              );
            })}
            {index !== footers.length - 1 && <>&nbsp;&nbsp;/</>}
          </Box>
        ))}
      </Box>
    </Box>
  );
}
